// @vendor
import React from 'react';
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @actions
const hireWelcomeAccountActions = require('actions/hireWelcomeAccount/hireWelcomeAccount');
const blockedAccountsAction = require('actions/blockedAccounts');
const contractsActions = require('actions/contracts');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profile = require('actions/profile');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
import preContractualPollingActions from 'actions/preContractualPolling';
import contractualPollingActions from 'actions/contractualPolling';
import getMainAccountActions from 'actions/getMainAccount'

// @components
import HireWelcomeAccountComponent from 'components/hireWelcomeAccount/HireWelcomeAccountComponent.js';
import { LoadingSection } from 'commonsComponents/loadingSection';

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    HIRE_WELCOME_ACCOUNT_CODE
} = require('constants/operationCodesAccounts');
import { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP } from '../../constants';
import { E_ACCOUNT_LOAN_PRODUCT_ALIAS, WELCOME_ACCOUNT_PRODUCT_ALIAS, WELCOME_ACCOUNT_PRECONTRACTUAL_PRODUCT_ALIAS } from 'constants/hiringProductInformation';

class HireWelcomeAccountView extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleLegalTextRead  = this.handleLegalTextRead .bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            getMainAccount,
            immAccounts,
            match: { params: { accountId } },
        } = this.props;
        
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_WELCOME_ACCOUNT_CODE);
        
        accountId && getMainAccount(accountId);
        !accountId && this.props.history.push('/myprofile/accounts');
    }
    
    fetchPrecontractualDocumentIfNecessary(prevProps) {
        const {
            getPrecontractualDocumentURLOrID,
            immHireWelcomeAccount,
            immProfileFields,
            match: { params: { accountId } },
        } = this.props;
        const isMainAccountFetched = immHireWelcomeAccount.getIn(['mainAccount', 'isFetching']);
        const prevIsMainAccountFetched = prevProps.immHireWelcomeAccount.getIn(['mainAccount', 'isFetching']);
    
        if (immHireWelcomeAccount.get('visibleStep') === WIZARD_FIRST_STEP && isMainAccountFetched && !prevIsMainAccountFetched) {
            getPrecontractualDocumentURLOrID({
                payload: {
                    "metadata": {
                        "productId": accountId,
                        "language": immProfileFields.get('originCountry')
                    },
                    "precontractualType": E_ACCOUNT_LOAN_PRODUCT_ALIAS
                }
            })
        }
    }

    startPrecontractualProcessIfNecessary() {
        const { immHireWelcomeAccount, preContractualPollingInitialization, immPreContractualPolling } = this.props;
        const isMainAccountFetched = immHireWelcomeAccount.getIn(['mainAccount', 'success']);
        const isPrecontractualDocumentFetched = immHireWelcomeAccount.getIn(['precontractualDocument', 'url']);
        const operationProcessId = immPreContractualPolling.get('operationProcessId');
        const operationProcessIdIsFetching = immPreContractualPolling.getIn(['init', 'isFetching']);

        if (
            immHireWelcomeAccount.get('visibleStep') === WIZARD_FIRST_STEP &&
            isMainAccountFetched &&
            isPrecontractualDocumentFetched &&
            !operationProcessId && !operationProcessIdIsFetching &&
            !immPreContractualPolling.getIn(['init', 'error'])
        ) {
            preContractualPollingInitialization(WELCOME_ACCOUNT_PRECONTRACTUAL_PRODUCT_ALIAS, null, isPrecontractualDocumentFetched, null, {
                precontractualDicUrl: immHireWelcomeAccount.getIn(['mainAccount', 'data', 'accountConfig', 'precontractualDicUrl']),
            });
        }
    }

    startContractualProcessIfNecessary(prevProps) {
        const { immHireWelcomeAccount, contractualPollingInitialization, immContractualPolling } = this.props;
        const visibleStep = immHireWelcomeAccount.get('visibleStep');
        const prevVisibleStep = prevProps.immHireWelcomeAccount.get('visibleStep');
        const precontractualDocument = immHireWelcomeAccount.getIn(['precontractualDocument', 'url']);
        const operationProcessId = immContractualPolling.get('operationProcessId');
        const operationProcessIdIsFetching = immContractualPolling.getIn(['init', 'isFetching']);

        if (visibleStep === WIZARD_THIRD_STEP && prevVisibleStep === WIZARD_SECOND_STEP &&
            !operationProcessId && !operationProcessIdIsFetching
        ) {
            contractualPollingInitialization(WELCOME_ACCOUNT_PRODUCT_ALIAS, null, precontractualDocument, {
                precontractualDicUrl: immHireWelcomeAccount.getIn(['mainAccount', 'data', 'accountConfig', 'precontractualDicUrl']),
            });
        };
    }

    callTermsAndCondsIfNecessary(prevProps) {
        const {
            immHireWelcomeAccount,
            setTermsAndCondsInfo,
            immPreContractualPolling,
            immTermsAndCondsInfo
        } = this.props;

        const prevVisibleStep = prevProps.immHireWelcomeAccount.get('visibleStep');
        const visibleStep = immHireWelcomeAccount.get('visibleStep');
        const operationProcessId = immPreContractualPolling.get('operationProcessId');
        const termsAndCondsSuccess = immTermsAndCondsInfo.get('requestSuccess');
        if (prevVisibleStep === WIZARD_FIRST_STEP && visibleStep === WIZARD_SECOND_STEP && !termsAndCondsSuccess) {
            setTermsAndCondsInfo(WELCOME_ACCOUNT_PRECONTRACTUAL_PRODUCT_ALIAS, [{
                passportProductId: WELCOME_ACCOUNT_PRECONTRACTUAL_PRODUCT_ALIAS,
            }], operationProcessId);
        }
    }

     componentDidUpdate(prevProps) {
        this.fetchPrecontractualDocumentIfNecessary(prevProps);
        this.startPrecontractualProcessIfNecessary();
        this.callTermsAndCondsIfNecessary(prevProps);
        this.startContractualProcessIfNecessary(prevProps)
    }

    componentWillUnmount() {
        const {
            resetBlockedAccounts,
            resetHireWelcome,
            resetPrecontractualDocument,
            resetPrecontractualMail,
            resetTermsAndCondsText,
            resetContractualPolling,
            resetPreContractualPolling,
        } = this.props;

        resetBlockedAccounts();
        resetHireWelcome();
        resetPrecontractualMail();
        resetTermsAndCondsText();
        resetPrecontractualDocument();
        resetPreContractualPolling();
        resetContractualPolling();
    }

    handleCancel = () => {
        this.props.history.push('/myprofile/accounts');
    }

    handleFinish = () => {
        const { finishWelcomeAccount, immContractualPolling, immHireWelcomeAccount } = this.props;
        const offerAccountData = immHireWelcomeAccount && immHireWelcomeAccount.getIn(['mainAccount', 'data']);
        finishWelcomeAccount({
            isPayroll: false,
            standard: offerAccountData.getIn(['accountDefinition', 'standard']),
            subType: offerAccountData.getIn(['accountDefinition', 'subtype']),
            type: offerAccountData.getIn(['accountDefinition', 'type']),
        }, immContractualPolling.get('operationProcessId'), true);
    }

    handleLegalTextRead = () => {
        const { setLegalTextRead } = this.props;
        setLegalTextRead();
    }

    isThereAnError = () => {
        const { immHireWelcomeAccount, immPreContractualPolling, immContractualPolling, immTermsAndCondsInfo } = this.props;
        const mainAccountError = immHireWelcomeAccount.getIn(['mainAccount', 'error']);
        const precontractualDocumentError = immHireWelcomeAccount.getIn(['precontractualDocument', 'error']);
        const pollingError = immPreContractualPolling.getIn(['polling', 'error']) || immContractualPolling.getIn(['polling', 'error']);
        const initError = immPreContractualPolling.getIn(['init', 'error']) || immContractualPolling.getIn(['init', 'error']);
        const documentsError = immPreContractualPolling.getIn(['documents', 'error']) || immContractualPolling.getIn(['documents', 'error']);
        const termsAndCondsError = !!immTermsAndCondsInfo.get('error');
        return mainAccountError || precontractualDocumentError || pollingError || initError || termsAndCondsError || documentsError;
    }

    render() {
        const {
            addIntervener,
            flagBasedFeatures,
            getContractInformation,
            immAccounts,
            immContractualPolling,
            immGlobalVariables,
            immHireWelcomeAccount, 
            immPreContractualPolling,
            immProfileFields,
            onCheckboxChange,
            preContractualMail,
            removeIntervener,
            requestInterveners,
            requestProfile,
            restoreDefaultInterveners,
            sendPreContractualMail,
            setIntervenerType,
            setSelectedAccountValue,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const shouldShowLoading = immHireWelcomeAccount.getIn(['mainAccount', 'isFetching']) || immHireWelcomeAccount.getIn(['precontractualDocument','isFetching']);
        if (shouldShowLoading) {
            return <LoadingSection />;
        }
        const breadcrumbTitle = formatText('hireWelcomeAccount-hireWelcomeAccount_welcomeAccountBreadcrumbTitle');
        const welcomeAccountTitle = formatText('hireWelcomeAccount-hireWelcomeAccount_welcomeAccountTitle');
        const confirmationSubtitle = 'hireWelcomeAccount-hireWelcomeAccount_step3Subtitle';
        const confirmationTitle = 'hireWelcomeAccount-hireWelcomeAccount_step3Title';
        const offerAccountData = immHireWelcomeAccount && immHireWelcomeAccount.getIn(['mainAccount', 'data']);
        const shouldSendButtonBeDisabled = !immHireWelcomeAccount.get('isLegalTextRead') || !immPreContractualPolling.getIn(['documents', 'success']);
        return (
            <HireWelcomeAccountComponent
                actions={actions}
                addIntervener={addIntervener}
                confirmationSubtitle={confirmationSubtitle}
                confirmationTitle={confirmationTitle}
                disableSendButton={shouldSendButtonBeDisabled}
                error={this.isThereAnError()}
                breadcrumbTitle={breadcrumbTitle}
                flagBasedFeatures={flagBasedFeatures}
                getContractInformation={getContractInformation}
                hasPolling
                immContractualPolling={immContractualPolling}
                immPreContractualPolling={immPreContractualPolling}
                immAccounts={immAccounts}
                immGlobalVariables={immGlobalVariables}
                immHireWelcomeAccount={immHireWelcomeAccount}
                isLegalTextRead={immHireWelcomeAccount.get('isLegalTextRead')}
                immProfileFields={immProfileFields}
                offerAccountData={offerAccountData}
                onLegalTextRead={this.handleLegalTextRead}
                onCheckboxChange={onCheckboxChange}
                operativeName={'welcomeAccount'}
                preContractualMail={preContractualMail}
                productName={breadcrumbTitle}
                removeIntervener={removeIntervener}
                requestInterveners={requestInterveners}
                requestProfile={requestProfile}
                restoreDefaultInterveners={restoreDefaultInterveners}
                sendPreContractualMail={sendPreContractualMail}
                setIntervenerType={setIntervenerType}
                setSelectedAccountValue={setSelectedAccountValue}
                setTermsAndCondsText={setTermsAndCondsText}
                standar={offerAccountData && offerAccountData.getIn(['accountDefinition', 'standard'])}
                subtype={offerAccountData && offerAccountData.getIn(['accountDefinition', 'subtype'])}
                title={welcomeAccountTitle}
                type={offerAccountData && offerAccountData.getIn(['accountDefinition', 'type'])}
            />
        )
    }
}

HireWelcomeAccountView.propTypes = {
    addIntervener: PropTypes.func.isRequired,
    contractualPollingInitialization: PropTypes.func.isRequired,
    finishWelcomeAccount: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func,
    getContractInformation: PropTypes.func.isRequired,
    getMainAccount: PropTypes.func.isRequired,
    getPrecontractualDocumentURLOrID: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immContractualPolling: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireWelcomeAccount: PropTypes.object.isRequired,
    immPreContractualPolling: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immTermsAndCondsInfo: PropTypes.object.isRequired,
    onCheckboxChange: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    preContractualPollingInitialization: PropTypes.func.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetHireWelcome: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    resetPrecontractualDocument: PropTypes.func,
    resetPreContractualPolling: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setIntervenerType: PropTypes.func.isRequired,
    setSelectedAccountValue: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
}

module.exports = HireWelcomeAccountView;
module.exports.HireWelcomeAccountView = connect (
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immGlobalVariables: state.globalVariables,
        immHireWelcomeAccount: state.hireWelcomeAccount,
        immProfileFields: state.profile,
        preContractualMail: state.preContractualMail,
        immPreContractualPolling: state.preContractualPolling,
        immContractualPolling: state.contractualPolling,
        immTermsAndCondsInfo: state.termsAndCondsInfo,
    }), {
        addIntervener: hireWelcomeAccountActions.addIntervener,
        contractualPollingInitialization: contractualPollingActions.contractualPollingInitialization,
        finishWelcomeAccount: hireWelcomeAccountActions.finishWelcomeAccount,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getContractInformation: contractsActions.getContractInformation,
        getMainAccount: getMainAccountActions.getMainAccount,
        getPrecontractualDocumentURLOrID: contractsActions.getPrecontractualDocumentURLOrID,
        onCheckboxChange: hireWelcomeAccountActions.onCheckboxChange,
        resetPreContractualPolling: preContractualPollingActions.resetPreContractualPolling,
        preContractualPollingInitialization: preContractualPollingActions.preContractualPollingInitialization,
        removeIntervener: hireWelcomeAccountActions.removeIntervener,
        requestInterveners: hireWelcomeAccountActions.requestInterveners,
        requestProfile: profile.requestProfile,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetHireWelcome: hireWelcomeAccountActions.resetHireWelcome,
        resetContractualPolling: contractualPollingActions.resetContractualPolling,
        resetPrecontractualDocument: hireWelcomeAccountActions.resetPrecontractualDocument,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        restoreDefaultInterveners: hireWelcomeAccountActions.restoreDefaultInterveners,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setIntervenerType: hireWelcomeAccountActions.setIntervenerType,
        setLegalTextRead: hireWelcomeAccountActions.setLegalTextRead,
        setSelectedAccountValue: hireWelcomeAccountActions.setSelectedAccountValue,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setTermsAndCondsInfo: termsAndCondsInfoActions.setTermsAndCondsInfo,
        setVisibleStep: hireWelcomeAccountActions.setVisibleStep,
        setWillCancel: hireWelcomeAccountActions.setWillCancel,
        validateStep: hireWelcomeAccountActions.validateStep
    }
)(withRouter(HireWelcomeAccountView));
